// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 471 ? "diary-page" : chunkId) + "." + {"471":"4d1426e3","544":"30a38c2f"}[chunkId] + ".chunk.css";
};